<template>
  <available-components-for-header
    v-if="headerMenuComponents && headerMenuComponents.length"
    :specific-components="headerMenuComponents"
  />
</template>

<script lang="ts">
import AvailableComponentsForHeader from '~/components/theme8/AvailableComponentsForHeader.vue';
import { TheHeaderMixin } from '~/units/core/mixins/theHeader.mixin';

export default defineNuxtComponent({
  name: 'Theme8BaseHeaderTheHeader',
  components: { AvailableComponentsForHeader },

  mixins: [TheHeaderMixin],
});
</script>
